import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import AddBusinessPartnerPopup from '../Popups/ItemRevision_popup_AddBusinessPartner';

const ItemRevision_tab_BusinessPartners: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId, refreshNr }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemId, itemRevisionId, refreshNr]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemBusinessPartners/ByItem/' + itemId + '/' + itemRevisionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { title: 'Name', dataProp: 'businessPartner.name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Type', dataProp: 'businessPartner.businessPartnerType.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Contactperson', dataProp: 'contactPerson.name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Contact info', dataProp: 'businessPartner.contactinfo', filterInfo: { filterType: 'Textbox' } },
        { title: 'Address', dataProp: 'businessPartner.address', filterInfo: { filterType: 'Textbox' } },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.UpdateItem, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemBusinessPartners'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Businesspartner'
                navigateUrl='/plm/BusinessPartners/Details/'
            />
            {showPopup && <AddBusinessPartnerPopup itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemRevision_tab_BusinessPartners;